import React from "react";
import { GraduationCap, Users, Sparkles, LucideCircleCheck } from "lucide-react";
import { Divider } from "antd";

export default function EnrolleeDetails({ selectedCourse, selectedMembers = [] }) {

  const courseName = selectedCourse?.title || "No course selected";
  const level = selectedCourse?.level || "N/A";
  const startDate = selectedCourse?.startDate || "TBA";
  const duration = selectedCourse?.duration || "TBA";
  const instructor = selectedCourse?.instructor || "TBA";

  return (
    <div className="space-y-6">
      <div className="p-5 rounded-xl bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-200">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-xl bg-purple-500">
            <GraduationCap className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-semibold text-[16px]">Course Details</h3>
        </div>

        <div className="text-[14px]">
          <div className="flex justify-between">
            <p>Course:</p>
            <p className="font-semibold">{courseName}</p>
          </div>

          <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-2">
              <div>
                <p>Start Date:</p>
                <p className="font-semibold">{startDate}</p>
              </div>

              <div>
                <p>Level:</p>
                <p
                  className={`inline-flex text-xs status-indicator ${
                    level.toLowerCase().replace(/\s+/g, "-")
                  }`}
                >
                  {level}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div>
                <p>Duration:</p>
                <p className="font-semibold">{duration}</p>
              </div>

              <div>
                <p>Instructor:</p>
                <p className="font-semibold">{instructor}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50 border-2 border-emerald-200">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-xl bg-emerald-500">
            <Users className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-semibold text-[16px]">
            Team Members ({selectedMembers.length})
          </h3>
        </div>

        <div className="space-y-2 max-h-[185px] overflow-y-auto">
          {selectedMembers.length > 0 ? (
            selectedMembers.map((member) => (
              <div
                key={member.id}
                className="flex items-center gap-3 p-2 rounded-lg bg-white border border-emerald-200"
              >
                <div className="flex items-center justify-center w-7 h-7 rounded-full gradient icon-emerald border-2 border-emerald-200 text-white text-[10px] font-semibold">
                  {member.initials ||
                    (member.name ? member.name.charAt(0) : "?")}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-[13px] font-semibold truncate">
                    {member.name || "Unnamed Member"}
                  </p>
                  <p className="text-[11px] text-muted-foreground truncate">
                    {member.role || "Team Member"}
                  </p>
                </div>
                <LucideCircleCheck
                  size={16}
                  className="text-emerald-600 flex-shrink-0"
                />
              </div>
            ))
          ) : (
            <p className="text-sm text-muted-foreground">
              No team members selected.
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 p-4 rounded-xl bg-slate-50 border border-slate-200 text-[13px] text-muted-foreground text-center">
        <Sparkles className="w-4 h-4 text-amber-600" />
        All team members will receive enrollment confirmation via email
      </div>
    </div>
  );
}
